module.exports = __webpack_public_path__ + "img/NPM.0a78c004.png";